import { z } from 'zod'

import extract from '../../function/extract'
import Axios from '../../function/axiosInstance'

const paramSchema = z.object({ search_code: z.string() })

interface ProjectResponse {
  total_records: number
  records: Project[]
}

export const getProjectByIDs = async (
  projectIds: number[]
): Promise<ApiResponseV2<ProjectResponse>> => {
  try {
    paramSchema.parse({ search_code: projectIds.join(',') })
    const response = await Axios.get('/projects', {
      params: { search_code: projectIds.join(',') }
    })
    return extract.data<ProjectResponse>(response)
  } catch (error) {
    return extract.error(error)
  }
}
